import { React, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import "../../styles/EventOverview.css";
import { InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

function EventAttendees(props) {
    const {
        membershipLvls,
        registeredContacts,
    } = props;
    const [employerFilter, setEmployerFilter] = useState(["Any"]);
    const [membershipFilter, setMembershipFilter] = useState(["Any"]);
    const [alumniFilter, setAlumniFilter] = useState(0);
    const [filteredContacts, setFilteredContacts] = useState([]);

    function filterFunction(contact) {
        if(employerFilter.length > 0 && !employerFilter.includes(contact.employerName) && !employerFilter.includes("Any")) {
            return false;
        }
        if(membershipFilter.length > 0 && !membershipFilter.includes(contact.membershipType) && !membershipFilter.includes("Any")) {
            return false;
        }
        if(alumniFilter == 1 && contact.major === "") {
            return false;
        }
        if(alumniFilter == 2 && contact.major !== "") {
            return false;
        }
        return true;
    }

    useEffect(() => {
        const fc = registeredContacts.filter(contact => filterFunction(contact));
        setFilteredContacts(fc);
    }, [employerFilter, membershipFilter, alumniFilter]);

    function handleEmployerFilter(newFilter) {
        //console.log(`oldFilter = ${employerFilter} \n newFilter = ${newFilter}`);
        if(newFilter.length === 0) {
            setEmployerFilter(["Any"]);
        } else if(!employerFilter.includes("Any") && newFilter.includes("Any")) {
            setEmployerFilter(["Any"]);
        } else if(newFilter.length > 1 && newFilter.includes("Any")) {
            setEmployerFilter(newFilter.filter(employer => employer != "Any"));
        } else {
            setEmployerFilter(newFilter);
        }
    }

    function handleMembershipFilter(newFilter) {
        //console.log(`oldFilter = ${membershipFilter} \n newFilter = ${newFilter}`);
        if(newFilter.length === 0) {
            setMembershipFilter(["Any"]);
        } else if(!membershipFilter.includes("Any") && newFilter.includes("Any")) {
            setMembershipFilter(["Any"]);
        } else if(newFilter.length > 1 && newFilter.includes("Any")) {
            setMembershipFilter(newFilter.filter(membership => membership != "Any"));
        } else {
            setMembershipFilter(newFilter);
        }
    }
    
    return (
        <div className="EventOverview-container rounded-xl bg-white px-6 py-16 flex flex-col overflow-y-auto">
            <div className="EventAttendees-FilterContainer">
                <div className="EventAttendees-Filter">
                    <InputLabel>Employer</InputLabel>
                    <Select
                        id="employerFilter"
                        className="EventAttendees-FilterSelect"
                        value={employerFilter}
                        onChange={(e) => handleEmployerFilter(e.target.value)}
                        multiple
                    >
                        <MenuItem value="Any">Any</MenuItem>
                        {[...new Set(registeredContacts.map(c => c.employerName))].map((emp, index) => (
                            <MenuItem key={index} value={emp}>{emp}</MenuItem>
                        ))}
                    </Select>
                </div>
                <div className="EventAttendees-Filter">
                    <InputLabel>Partnership Level</InputLabel>
                    <Select
                        id="mLvlFilter"
                        className="EventAttendees-FilterSelect"
                        value={membershipFilter}
                        onChange={(e) => handleMembershipFilter(e.target.value)}
                        multiple
                    >
                        <MenuItem value="Any">Any</MenuItem>
                        {membershipLvls.map((ml, index) => (
                            <MenuItem key={index} value={ml}>{ml}</MenuItem>
                        ))}
                    </Select>
                </div>
                <div className="EventAttendees-Filter">
                    <InputLabel>Alumni</InputLabel>
                    <Select
                        id="alumFilter"
                        className="EventAttendees-FilterSelect"
                        value={alumniFilter}
                        onChange={(e) => setAlumniFilter(e.target.value)}
                    >
                        <MenuItem value={0}>Any</MenuItem>
                        <MenuItem value={1}>Alumni</MenuItem>
                        <MenuItem value={2}>Not Alumni</MenuItem>
                    </Select>
                </div>
            </div>
            <br />
            <TableContainer>
                <Table>
                    <TableHead className="EventAttendees-TableHeader">
                        <TableRow>
                            <TableCell sx={{ display: "None" }}>Employer</TableCell>
                            <TableCell>Employer</TableCell>
                            <TableCell>Partnership Level</TableCell>
                            <TableCell>Contact&#39;s Name</TableCell>
                            <TableCell>Contact&#39;s Alumni Info</TableCell>
                            <TableCell>Contact&#39;s Email</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredContacts.map((contact, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ display: "None" }}>{contact.employerName}</TableCell>
                                <TableCell>{contact.employerName}</TableCell>
                                <TableCell>{contact.membershipType}</TableCell>
                                <TableCell>{contact.name}</TableCell>
                                <TableCell>{contact.major}</TableCell>
                                <TableCell>{contact.email}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

EventAttendees.propTypes = {
    membershipLvls: PropTypes.array,
    registeredContacts: PropTypes.array
};

EventAttendees.defaultProps = {
    membershipLvls: [],
    registeredContacts: [],
};

export default EventAttendees;